module.exports = __webpack_public_path__ + "img/icon_map_63_off_001.edf32297.png";